//
// Module for the DROP Disbursement Periodic wizard's Disbursement Options step
//
rs.module("participant/benefit/setup/dropdisbursement/periodic/wizard/disbursementoptionsstep",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors) {

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var dropAnnuityMonthlyBenefitInput = stepContainer.js(jsSelectors.dropAnnuityMonthlyBenefitInput, { required: false });
            var dropAnnuityLumpSumInput = stepContainer.js(jsSelectors.dropAnnuityLumpSumInput, { required: false });
            var dropTermPaymentsInput = stepContainer.js(jsSelectors.dropTermPaymentsInput, { required: false });
            var dropTermYearsInput = stepContainer.js(jsSelectors.dropTermYearsInput, { required: false });
            var dropTermBenefitTerminationDate = stepContainer.js(jsSelectors.dropTermBenefitTerminationDate, { required: false });

            // Hookup dropAnnuityMonthlyBenefitInput and dropAnnuityLumpSumInput change events
            dropAnnuityMonthlyBenefitInput.on('input', dropAnnuityMonthlyBenefitChange);
            dropAnnuityLumpSumInput.on('input', dropAnnuityLumpSumChange);

            // Hookup dropTermPaymentsInput, dropTermYearsInput and dropTermBenefitTerminationDate change events
            dropTermPaymentsInput.on('input', dropTermPaymentsChange);
            dropTermYearsInput.on('input', dropTermYearsChange);
            dropTermBenefitTerminationDate.on('input', dropTermBenefitTerminationDateChange);

            // On dropAnnuityMonthlyBenefitInput change
            function dropAnnuityMonthlyBenefitChange() {

                var valueEntered = currencyAmountHasValue(dropAnnuityMonthlyBenefitInput.val());

                // If a value for monthly benefit amount is entered, disable and clear the lump sum amount input
                dropAnnuityLumpSumInput.prop('disabled', valueEntered);
                if (valueEntered) {
                    dropAnnuityLumpSumInput.val("").clearErrors();
                }
            }

            // On dropAnnuityLumpSumInput change
            function dropAnnuityLumpSumChange() {

                var valueEntered = currencyAmountHasValue(dropAnnuityLumpSumInput.val());

                // If a value for payments is entered, disable and clear the years input
                dropAnnuityMonthlyBenefitInput.prop('disabled', valueEntered);
                if (valueEntered) {
                    dropAnnuityMonthlyBenefitInput.val("").clearErrors();
                }
            }

            // On dropTermPaymentsInput change
            function dropTermPaymentsChange() {

                var paymentsEntered = dropTermPaymentsInput.val() !== '';

                // If a value for payments is entered, disable and clear the years and term date inputs
                dropTermYearsInput.prop('disabled', paymentsEntered);
                dropTermBenefitTerminationDate.prop('disabled', paymentsEntered);
                if (paymentsEntered) {
                    dropTermYearsInput.val("").clearErrors();
                    dropTermBenefitTerminationDate.val("").clearErrors();
                }
            }

            // On dropTermYearsInput change
            function dropTermYearsChange() {

                var yearsEntered = dropTermYearsInput.val() !== '';

                // If a value for years is entered, disable and clear the payments and term date inputs
                dropTermPaymentsInput.prop('disabled', yearsEntered);
                dropTermBenefitTerminationDate.prop('disabled', yearsEntered);
                if (yearsEntered) {
                    dropTermPaymentsInput.val("").clearErrors();
                    dropTermBenefitTerminationDate.val("").clearErrors();
                }
            }

            // On dropTermBenefitTerminationDate change
            function dropTermBenefitTerminationDateChange() {

                var dateEntered = dropTermBenefitTerminationDate.val() !== '';

                // If a value for term date is entered, disable and clear the years and payments inputs
                dropTermYearsInput.prop('disabled', dateEntered);
                dropTermPaymentsInput.prop('disabled', dateEntered);
                if (dateEntered) {
                    dropTermYearsInput.val("").clearErrors();
                    dropTermPaymentsInput.val("").clearErrors();
                }
            }

            // Return true if supplied currency amount has a nonzero value
            function currencyAmountHasValue(amount) {
                return $.getNormalizedCurrencyValue(amount) != 0;
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);